import { Suspense } from "react";
import { UsageCharts } from "@/app/billing/overview/components/usage-charts";
import { useGetCapabilities } from "@/app/capabilities/api/hooks";
import { CardsSkeleton } from "../skeletons/dashboard-skeletons";
import { AllocationsWidget } from "./allocations-widget";

export function CardsWidget() {
  const { data: capabilities, isPending } = useGetCapabilities();
  const billingVisible = capabilities?.billing.enabled ?? false;
  if (isPending) {
    // Most deployments have billing enabled, so show a stable loading skeleton first.
    return <CardsSkeleton />;
  }
  if (!billingVisible) {
    return null;
  }

  return (
    <Suspense fallback={<CardsSkeleton />}>
      <UsageCharts fallback={<AllocationsWidget />} showEmptyState={false} />
    </Suspense>
  );
}
